import React, { useRef } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';

// Lenguaje de movimiento del modulo de Proyectos. La camara del Gantt usa el
// mismo resorte sin rebote que el organigrama; las tarjetas, uno mas vivo
// porque responden a la mano.

export const RESORTE_TARJETA = { type: 'spring', stiffness: 380, damping: 30, mass: 0.8 };
export const RESORTE_ALZAR = { type: 'spring', stiffness: 520, damping: 32 };
export const RESORTE_HUECO = { type: 'spring', stiffness: 420, damping: 38 };
export const RESORTE_COLUMNA = { type: 'spring', stiffness: 320, damping: 34 };
export const CAMARA_T = { type: 'spring', duration: 0.8, bounce: 0 };

// Una tarjeta agarrada crece apenas y proyecta una sombra larga, como si se
// despegara del tablero.
export const ESCALA_ALZADA = 1.035;
export const SOMBRA_NULA = '0 0px 0px 0px rgba(15,23,42,0), 0 0px 0px 0px rgba(15,23,42,0)';
export const SOMBRA_ALZADA = '0 22px 44px -14px rgba(15,23,42,0.35), 0 6px 14px -6px rgba(15,23,42,0.18)';

// Numero que rueda al cambiar: sube cuando aumenta y baja cuando disminuye,
// asi se lee hacia donde se movio una tarea sin mirar las dos columnas.
const variantesNumero = {
  entra: (dir) => ({ y: dir > 0 ? '70%' : '-70%', opacity: 0 }),
  quieto: { y: '0%', opacity: 1 },
  sale: (dir) => ({ y: dir > 0 ? '-70%' : '70%', opacity: 0 }),
};

// Texto que rueda al cambiar, hacia el lado que se le indique (1 sube, -1 baja).
export const TextoRodante = ({ valor, direccion = 1, className = '' }) => {
  const reduce = useReducedMotion();
  if (reduce) return <span className={className}>{valor}</span>;
  return (
    <span className={`relative inline-flex overflow-hidden ${className}`}>
      <AnimatePresence mode="popLayout" initial={false} custom={direccion}>
        <motion.span
          key={valor}
          custom={direccion}
          variants={variantesNumero}
          initial="entra"
          animate="quieto"
          exit="sale"
          transition={{ type: 'spring', stiffness: 520, damping: 34 }}
        >
          {valor}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};

export const NumeroRodante = ({ valor, className = '' }) => {
  const previo = useRef(valor);
  const direccion = useRef(1);
  if (previo.current !== valor) {
    direccion.current = valor > previo.current ? 1 : -1;
    previo.current = valor;
  }
  return <TextoRodante valor={valor} direccion={direccion.current} className={`tabular-nums ${className}`} />;
};
